export default function MatchAnalysisByEvent({ user, signOut }) {}
